import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Select-Button--Streamline-Flex"
    >
        <desc>{'Select Button Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="select-button--radio-button-select-ui-interface-check">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 13.5c4.16 0 6.5 -2.34 6.5 -6.5S11.16 0.5 7 0.5 0.5 2.84 0.5 7s2.34 6.5 6.5 6.5Z"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 10.5c2.24 0 3.5 -1.26 3.5 -3.5S9.24 3.5 7 3.5 3.5 4.76 3.5 7s1.26 3.5 3.5 3.5Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
